import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
    Box,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@mui/material";

const acceptedFileTypes = ".csv,.pdf,.jpeg,.jpg";

const getFileHelperText = (files) => {
    return files?.[0]?.name || "Accepted: CSV, PDF, JPEG, JPG";
};

const OtherDetailsFields = ({ formData, handleFormDataChange }) => {
    const isAgreement = formData.is_agreement_available === "1";
    const noAgreement = formData.is_agreement_available === "0";

    return (
        <div className="row">
            <div className="col-md-12 p-2">
                <FormControl>
                    <FormLabel id="agreement-available-label">Is Vendor Agreement Available? *</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="agreement-available-label"
                        name="is_agreement_available"
                        value={formData.is_agreement_available ?? ""}
                        onChange={(event) => handleFormDataChange(event)}
                    >
                        <FormControlLabel value="1" control={<Radio />} label="Yes" />
                        <FormControlLabel value="0" control={<Radio />} label="No" />
                    </RadioGroup>
                </FormControl>
            </div>
            <div className="col-md-12 p-2">
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 1.5,
                        py: 1.25,
                        borderRadius: 1,
                        backgroundColor: "#f6f8fb",
                        color: "#475467",
                    }}
                >
                    <InfoOutlinedIcon fontSize="small" />
                    <Typography variant="body2">
                        Document upload is required in case of availability of agreement.
                    </Typography>
                </Box>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        type="file"
                        label={isAgreement ? "Contract Copy *" : "Contract Copy"}
                        name="contract_copy"
                        onChange={(event) => handleFormDataChange(event, true)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ accept: acceptedFileTypes }}
                        helperText={getFileHelperText(formData.contract_copy)}
                        disabled={noAgreement}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        type="file"
                        label={isAgreement ? "Firm Registration Certificate *" : "Firm Registration Certificate"}
                        name="reg_cert"
                        onChange={(event) => handleFormDataChange(event, true)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ accept: acceptedFileTypes }}
                        helperText={getFileHelperText(formData.reg_cert)}
                        disabled={noAgreement}
                    />
                </FormControl>
            </div>
            
            <div className="col-md-12 p-2">
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 1.5,
                        py: 1.25,
                        borderRadius: 1,
                        backgroundColor: "#f6f8fb",
                        color: "#475467",
                    }}
                >
                    <InfoOutlinedIcon fontSize="small" />
                    <Typography variant="body2">
                        Minimum one document required: Authority Letter, Cancel Cheque Copy, or PAN Card.
                    </Typography>
                </Box>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        type="file"
                        label="FC/UBS/NEFT/Authority Letter"
                        name="authority_letter"
                        onChange={(event) => handleFormDataChange(event, true)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ accept: acceptedFileTypes }}
                        helperText={getFileHelperText(formData.authority_letter)}
                    />
                </FormControl>
            </div>
            {/* <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        type="file"
                        label="Invoice / Letter Head"
                        name="letter_head"
                        onChange={(event) => handleFormDataChange(event, true)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ accept: acceptedFileTypes }}
                        helperText={getFileHelperText(formData.letter_head)}
                    />
                </FormControl>
            </div> */}
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        type="file"
                        label="Cancel Cheque Copy"
                        name="cancel_cheque"
                        onChange={(event) => handleFormDataChange(event, true)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ accept: acceptedFileTypes }}
                        helperText={getFileHelperText(formData.cancel_cheque)}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        type="file"
                        label="PAN Card"
                        name="pan_card"
                        onChange={(event) => handleFormDataChange(event, true)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ accept: acceptedFileTypes }}
                        helperText={getFileHelperText(formData.pan_card)}
                    />
                </FormControl>
            </div>
        </div>
    );
};

export default OtherDetailsFields;